/**
 * Message Type that can be sent to a ChargePoint
 */
export enum ConfigurationKeys {
    AdditionalRootCertificateCheck = 'AdditionalRootCertificateCheck',
    AllowOfflineTxForUnknownId = 'AllowOfflineTxForUnknownId',
    AuthorizationCacheEnabled = 'AuthorizationCacheEnabled',
    AuthorizationKey = 'AuthorizationKey',
    AuthorizeRemoteTxRequests = 'AuthorizeRemoteTxRequests',
    BlinkRepeat = 'BlinkRepeat',
    CentralContractValidationAllowed = 'CentralContractValidationAllowed',
    CertificateSignedMaxChainSize = 'CertificateSignedMaxChainSize',
    CertSigningWaitMinimum = 'CertSigningWaitMinimum',
    CertSigningRepeatTimes = 'CertSigningRepeatTimes',
    CertificateStoreMaxLength = 'CertificateStoreMaxLength',
    ClockAlignedDataInterval = 'ClockAlignedDataInterval',
    ConnectionTimeOut = 'ConnectionTimeOut',
    ConnectorPhaseRotation = 'ConnectorPhaseRotation',
    ContractValidationOffline = 'ContractValidationOffline',
    CpoName = 'CpoName',
    HeartbeatInterval = 'HeartbeatInterval',
    ISO15118PnCEnabled = 'ISO15118PnCEnabled',
    LightIntensity = 'LightIntensity',
    LocalAuthListEnabled = 'LocalAuthListEnabled',
    LocalAuthorizeOffline = 'LocalAuthorizeOffline',
    LocalPreAuthorize = 'LocalPreAuthorize',
    MaxEnergyOnInvalidId = 'MaxEnergyOnInvalidId',
    MeterValueSampleInterval = 'MeterValueSampleInterval',
    MinimumStatusDuration = 'MinimumStatusDuration',
    ResetRetries = 'ResetRetries',
    SecurityProfile = 'SecurityProfile',
    StopTransactionOnEVSideDisconnect = 'StopTransactionOnEVSideDisconnect',
    StopTransactionOnInvalidId = 'StopTransactionOnInvalidId',
    TransactionMessageAttempts = 'TransactionMessageAttempts',
    TransactionMessageRetryInterval = 'TransactionMessageRetryInterval',
    UnlockConnectorOnEVSideDisconnect = 'UnlockConnectorOnEVSideDisconnect',
    WebSocketPingInterval = 'WebSocketPingInterval'
}
